/** @jsxImportSource theme-ui */
import { Button as ThemeUIButton, ButtonProps, Spinner, Flex, Box } from 'theme-ui';

interface Props extends ButtonProps {
    isLoading?: boolean;
}

const Button: React.FC<Props> = ({ children, isLoading, ...restProps }) => {
    return (
        <ThemeUIButton {...restProps}>
            <Box sx={{ position: 'relative' }}>
                <Flex sx={{ visibility: isLoading ? 'hidden' : 'visible' }}>{children}</Flex>
                {isLoading ? (
                    <Flex
                        sx={{
                            justifyContent: 'center',
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                        }}
                    >
                        <Spinner
                            variant={restProps.variant ? `styles.spinner.${restProps.variant}` : ''}
                            size={16}
                        />
                    </Flex>
                ) : null}
            </Box>
        </ThemeUIButton>
    );
};

export default Button;
